import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../Contexts/AuthContext';
import avatar from '../assets/Avatar2.png';
import './Header.css';
import ThemeToggle from './ThemeToggle';

function Header() {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const { logout, user } = useAuth();
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const userPicture = user?.picture || avatar;
  const userName = user?.name || user?.preferred_username || user?.email || 'Account';

  return (
    <header id="header">
      <div className="controls-wrapper">
        <ThemeToggle />
        {/* <div className="separator"></div> */}
        <div className="user-account" ref={dropdownRef}>
          <button className="user-button" onClick={toggleMenu}>
            <img className="user-image" src={userPicture} alt="avatar" />
            <span>{userName}</span>
            {/* <span>{user?.email}</span> */}
          </button>
          <div className={`dropdown-menu ${menuOpen ? 'open' : 'closed'}`}>
            <ul>
              <li>
                <Link to="/my-account">
                  <div className="icon-wrapper">
                    <i className="fa-solid fa-address-card"></i>
                  </div>
                  My Account
                </Link>
              </li>
              <li>
                <button
                  onClick={() => {
                    const currentUrl = window.location.origin;

                    // Broadcast logout event to all tabs
                    localStorage.setItem('logout', Date.now().toString());

                    // Keycloak logout (через AuthContext) і редірект на корінь
                    logout({ returnTo: `${currentUrl}/` });
                  }}
                  className="logout-button"
                >
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
